var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-2"},[_c('div',{ref:"map",attrs:{"id":"map"}}),_c('v-btn',{staticClass:"text-capitalize my-1",attrs:{"outlined":"","rounded":""},on:{"click":function($event){return _vm.drawHeatmap()}}},[_vm._v("Draw Heat Map")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }